function Footer() {
    return (
        <div className="w-full bg-black flex justify-center items-center">
            <p className="text-cream font-light p-4">Website by <a target="_blank" rel="noreferrer" href="https://farhantajwar.com"><u className="font-bold text-purple transition duration-100 ease-in hover:text-darkPurple active:text-veryDarkPurple">Farhan Tajwar Romit</u></a></p>
        </div>
    );
}

export default Footer;